<template>
  <div>
    <el-button
      v-bind:style="{ color: rowdata.ifimg ? 'blue' : 'red' }"
      type="text"
      @click="
        fetchimg();
        imgdialog = true;
      "
    >
      &#x1F441;
      <!-- <i class="el-icon-view"></i> -->
    </el-button>

    <el-dialog v-if="imgdialog" :visible.sync="imgdialog">
      <p v-show="imgurl === null">未上传图片</p>
      <img :src="imgurl" style="width: 100%" />

      <div
        v-if="
          $store.state.roles.includes('dbadmin') ||
          $store.state.user === rowdata.name
        "
      >
        <el-upload
          :on-change="handlechange"
          :file-list="filelist"
          :auto-upload="false"
          action
        >
          <el-button
            slot="trigger"
            style="margin-top: 1rem"
            size="small"
            type="primary"
            >选择图片</el-button
          >
          <!-- <br /> -->
        </el-upload>

        <el-button
          style="margin-top: 1rem"
          type="success"
          v-if="imgready"
          @click="imgsubmit"
          >上传</el-button
        >
        <br/>
        <textarea id="pastearea"  placeholder="img paste" @paste="onpaste" contenteditable></textarea>
        <br/>
        <el-button
          v-show="rowdata.ifimg"
          @dblclick.native="imgdelete()"
          style="margin-top: 1rem"
          size="small"
          type="danger"
          >删除图片</el-button
        >
      </div>

      <el-button
        style="margin-top: 2rem"
        v-if="imgurl != null"
        @click="imgdownload"
        >下载图片</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import minifyimg from "./minifyimg.js";
export default {
  props: ["rowdata"],
  data() {
    return {
      blob:{},
      imgready:false,
      imgdialog: false,
      imgurl: null,
      formdata: null,
      filelist: [],
    };
  },
  computed: {
    thecollection() {
      return this.$store.state.collection.value;
    },
  },

  mounted() {},
  methods: {
    fetchimg() {
      if (!this.rowdata.ifimg) {
        return;
      }
      let self = this;
      // fetch(url + "showimg?id=" + this.rowdata._id)
      fetch(url + "img/" + this.thecollection+"/"+this.rowdata._id+".jpg")
        .then((res) => {
          if (res.status === 404) {
            self.imgurl = null;
            return;
          }
          return res.blob();
        })
        .then((blob) => {
          self.imgurl = URL.createObjectURL(blob);
        });
    },
    handlechange(file, filelist) {
      if (!file.raw.type.includes("image")) {
        this.$message("只能上传图片");
        return;
      }
      let self = this;
      this.filelist = filelist.slice(-1); //只允许上传一个
      //   let formdata = new FormData();

      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onloadend = function () {
        // formdata.append("_id", self.rowdata._id);
        // formdata.append("clct", self.thecollection);

        minifyimg(reader.result, 800).then((canvas) => {
          self.imgurl = canvas.toDataURL("image/jpeg", 1);
          canvas.toBlob(
            (blob) => {
            //   self.formdata.append("img", blob);
            self.blob=blob
              self.imgready=true
              //   self.formdata = formdata;
            },
            "image/jpeg",
            0.6
          );
        });
      };
    },

       //https://stackoverflow.com/questions/6333814/how-does-the-paste-image-from-clipboard-functionality-work-in-gmail-and-google-c
    onpaste(event) {
      var items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;
      //console.log(JSON.stringify(items)); // will give you the mime types
      // find pasted image among pasted items
      var blob = null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") === 0) {
          blob = items[i].getAsFile();
        }
      }
      // load image if there is a pasted image
      if (blob !== null) {
        this.imgready=true
        this.imgurl =URL.createObjectURL(blob)// canvas.toDataURL("image/jpeg", 1)
        // this.formdata.append("img", blob);
        this.blob=blob
      }
    },

    imgsubmit() {
        
     let self=this
     this.formdata=new FormData()
     //要非常注意formdata的顺序，blob需要放在最后
      this.formdata.append("_id", self.rowdata._id);
      this.formdata.append("clct", self.thecollection);
      this.formdata.append("img", self.blob)

      this.$axios({
        method: "post",
        url: url + "imgupload",
        data: this.formdata,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        this.$message("图片已上传");
        this.imgready=false;
        this.imgdialog = false;
        this.rowdata.ifimg = true;
        this.filelist = [];
      });
      //this.$axios.post(url + "imgupload", this.formdata)
    },

    imgdelete() {
      this.$axios({
        method: "post",
        url: url + "imgdelete",
        data: { _id: this.rowdata._id, clct: this.thecollection },
        // config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        this.$message("图片已删除");
        this.imgdialog = false;
        this.rowdata.ifimg = false;
        // this.imgdialog=false
        // this.filelist = [];
      });
    },

    imgdownload() {
      this.$emit("done");
      let link = document.createElement("a");
      link.download = this.rowdata._id + ".jpg";
      link.href = this.imgurl;
      link.click();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/imgdialog.vue